import { useAuthenticatedUser } from './useAuthenticatedUser';

export function useHasAnyPermission(permissions: string[]): boolean {
  const user = useAuthenticatedUser();

  return permissions.some((permission) => user.hasPermission(permission));
}
